import { Input, Label } from "abs-ui-components";
import { MDBCol, MDBRow } from "mdbreact";
import "./FEUChildDerogations.scss"
import { roundOff } from "../../../../../../../services/utilities";

const FEUChildDerogations = ({ windDerogations, iceDerogations }) => {

    const safeValue = (val) =>
        val === null || val === undefined || val === "" ? "" : val;

    return (
        <>
            <div className="mt-2 feu-reporsummary-container feu-derogation m-3">
                {windDerogations?.length > 0 && (
                    <MDBRow className="mb-0">
                        <MDBCol className="col-10 pl-0">
                            <p className="header-text">{"b) Wind Derogations"}</p>
                        </MDBCol>
                    </MDBRow>
                )}

                {windDerogations?.map((row, index) => (
                    <div key={`feuenergyconsumption-${index}`} className="mt-1">
                        <MDBRow className="mb-0">
                            <MDBCol className="col-2 d-flex align-items-center">
                                <Label name={`b.${index + 1}) ${row?.description}`} />
                            </MDBCol>

                            <MDBCol className="col-2">
                                <MDBRow>
                                    <MDBCol>
                                        <Input
                                            title={safeValue(row.value)}
                                            value={
                                                safeValue(row.value) !== ""
                                                    ? roundOff(row.value, 3, 3)
                                                    : ""
                                            }
                                            autoFocus={false}
                                            className="report-summmery-input"
                                            readOnly
                                        />
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </div>
                ))}
            </div>

            <div className="mt-2 feu-reporsummary-container feu-derogation m-3 pt-3">
                {iceDerogations?.length > 0 && (
                    <MDBRow>
                        <MDBCol className="col-10 pl-0">
                            <p className="header-text">{"c) Ice Derogations"}</p>
                        </MDBCol>
                    </MDBRow>
                )}

                {iceDerogations?.map((row, index) => {
                    const isDecimal = !isNaN(parseFloat(row.value)) && isFinite(row.value);

                    return (
                        <div key={`feuenergyconsumption-${index}`} className="mt-1">
                            <MDBRow className="mb-0">
                                <MDBCol className="col-2 d-flex align-items-center">
                                    <Label name={`c.${index + 1}) ${row?.description}`} />
                                </MDBCol>

                                <MDBCol className="col-2">
                                    <MDBRow>
                                        <MDBCol>
                                            <Input
                                                title={safeValue(row.value)}
                                                value={
                                                    safeValue(row.value) === ""
                                                        ? ""
                                                        : isDecimal
                                                            ? roundOff(row.value, 3, 3)
                                                            : row.value
                                                }
                                                autoFocus={false}
                                                className="report-summmery-input"
                                                readOnly
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>

                                <MDBCol className="col-1 pl-0 d-flex align-items-center">
                                    <Label name={row?.units} />
                                </MDBCol>
                            </MDBRow>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default FEUChildDerogations;
